module.exports = __webpack_public_path__ + "img/oem4.11aaad0f.png";